import {
    IEditorEventHandler, IEditorUndoRedoEventProps,
} from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/components/text-editor/interface/editor-event.interface';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';

const ctrlKey = browser.isMac ? 'metaKey' : 'ctrlKey';

/**
 * 处理undo redo 事件
 */
export class UndoRedoEventHandler implements IEditorEventHandler {
    private triggerRedo: IEditorUndoRedoEventProps['triggerRedo'];
    private triggerUndo: IEditorUndoRedoEventProps['triggerUndo'];

    // eslint-disable-next-line no-useless-constructor
    public constructor({ triggerRedo, triggerUndo }: IEditorUndoRedoEventProps) {
        this.triggerRedo = triggerRedo;
        this.triggerUndo = triggerUndo;
    }

    public handleKeyZEvent(evt: KeyboardEvent): boolean {
        if (evt[ctrlKey]) {
            evt.preventDefault?.();
            evt.stopPropagation?.();

            if (browser.isMac) {
                if (evt.shiftKey) {
                    this.triggerRedo();
                } else {
                    this.triggerUndo();
                }
                return true;
            }

            this.triggerUndo();
            return true;
        }

        return false;
    }

    public handleKeyYEvent(evt: KeyboardEvent): boolean {
        if (evt[ctrlKey]) {
            evt.preventDefault?.();
            evt.stopPropagation?.();
            this.triggerRedo();
            return true;
        }
        return false;
    }
}
